function titleCaseStatus(value) {
  return String(value || "")
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (ch) => ch.toUpperCase());
}

/** Confirmed / Seized / New for vehicle search and detail screens. */
export function resolveVehicleDisplayStatus(item = {}) {
  const repo = String(item.repoStatus || "").toUpperCase();
  const seized =
    item.inventoryConfirmed === true ||
    Boolean(item.inventoryConfirmedAt) ||
    repo === "SEIZED";
  if (seized) return "Seized";

  const conf = String(
    item.confirmationStatus ||
      item.latestTrace?.status ||
      item.latestTraceReport?.status ||
      ""
  ).toUpperCase();
  if (conf === "CONFIRMED" || repo === "CONFIRMED") return "Confirmed";
  if (conf === "REJECTED" || repo === "CANCELLED") return "Rejected";
  if (!repo || repo === "NEW" || repo === "PENDING_CONFIRMATION") return "New";
  return titleCaseStatus(repo) || "New";
}
